// frontend/src/i18n.ts

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const isDemoMode = process.env.REACT_APP_DEMO_MODE === 'true';

const baseConfig = {
    fallbackLng: 'en',
    // fallbackLng: 'fr',
    debug: true,
    interpolation: {
        escapeValue: false, // Not needed for React
    },
    react: {
        useSuspense: false,
    },
};

if (isDemoMode) {
    console.log('Running in DEMO mode: i18n backend is disabled.');
    i18n
        .use(initReactI18next)
        .init({
            ...baseConfig,
            resources: {
                en: { translation: {} },
                fr: { translation: {} }
            }
        });
} else {
    i18n
        .use(initReactI18next)
        .use(HttpBackend)
        .use(LanguageDetector)
        .init({
            ...baseConfig,
            backend: {
                // loadPath: '/api/translations/{{lng}}/', // API endpoint for translations
                loadPath: '/api/translations/lang/{{lng}}/', // API endpoint for translations
            },
        });
}

export default i18n;
